/**
 * The notifications module's routes, owned by the feature (D5).
 */
import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const NotificationTemplatesPage = lazy(() => import('./NotificationTemplatesPage'));

export const notificationRoutes: RouteObject[] = [
    { path: 'notifications', element: <NotificationTemplatesPage /> },
];
